import {Config} from "./app/services/config.service";

export const CONFIG: Config = {
    API_URL: "https://mankomeldung-backend.azm-dev.at/graphql",
    PAGE_SIZE: 20,
    ENVIRONMENT: 'development',
    DEVIATION_THRESHOLD: 0.5,
    BUGSNAG_KEY: "0d8eb9d967b96e877c5dfdda6b364dc9"
}